/* eslint-disable no-mixed-operators */
import Account from "../components/account";
import { useState, useEffect } from "react";
import { useLeagues } from "../context/leagues";
import "../components/booth/tokens.css";
import Toast from "../components/booth/Toast";
import MainBar from "../components/mainBar";
import LeagueStack from "../components/leagueStack";
import { useLocation, useNavigate } from "react-router-dom";
import "./Dashboard.css";

function Dashboard() {
  const leagues = useLeagues();
  const [league, setLeague] = useState(null);
  const [showAccount, setShowAccount] = useState(false);
  const [hasLoadedLeaguesOnce, setHasLoadedLeaguesOnce] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const location = useLocation();
  const navigate = useNavigate();

  // Handle URL parameters for checkout completion
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const sessionId = searchParams.get("session_id");

    if (sessionId) {
      setToast({
        open: true,
        message: "Payment completed successfully! Welcome to The Booth!",
        severity: "success",
      });

      // Clear URL parameters
      navigate("/dashboard", { replace: true });
    }
  }, [location.search, navigate, leagues]);

  // Once leagues have loaded the first time, never swap LeagueStack out
  // for the spinner again: a background refetch (e.g. triggered by a
  // focus-regain auth re-check) would otherwise unmount it and lose any
  // in-progress state, such as a typed-but-unsubmitted Add League form.
  useEffect(() => {
    if (!leagues.loading && !hasLoadedLeaguesOnce) {
      setHasLoadedLeaguesOnce(true);
    }
  }, [leagues.loading, hasLoadedLeaguesOnce]);

  const renderContent = () => {
    if (leagues.loading && !hasLoadedLeaguesOnce) {
      return (
        <div className="booth-dashboard-loading">
          <span>Loading leagues…</span>
        </div>
      );
    }
    if (showAccount) {
      return <Account onClose={() => setShowAccount(false)} />;
    }
    return <LeagueStack />;
  };

  return (
    <div className="booth booth-dashboard">
      <MainBar
        onAccountClick={() => {
          if (league !== null) {
            setLeague(null);
          }
          setShowAccount(!showAccount);
        }}
        showAccount={showAccount}
      />
      <main className="booth-dashboard-main">{renderContent()}</main>
      <Toast
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        onClose={() => setToast((t) => ({ ...t, open: false }))}
      />
    </div>
  );
}

export default Dashboard;
